import { render, staticRenderFns } from "./ResellerClientSearch.vue?vue&type=template&id=47bf5e59&"
import script from "./ResellerClientSearch.vue?vue&type=script&lang=js&"
export * from "./ResellerClientSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports